import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { createApiClient } from "../lib/api/client";

export function HealthCheck() {
  const { getToken } = useAuth();

  useEffect(() => {
    const warmUpApi = async () => {
      try {
        const api = createApiClient(() => getToken());
        await api.get("/health");
        console.log("API health check successful");
      } catch (error) {
        console.warn("API health check failed:", error);
      }
    };

    warmUpApi();
  }, [getToken]);

  return null;
} 